import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import RaceResult from "./RaceResult";

const WAKU_COLORS = {
  1: { bg: "#ffffff", text: "#000000", border: "#cccccc" },
  2: { bg: "#333333", text: "#ffffff", border: "#333333" },
  3: { bg: "#ff9999", text: "#000000", border: "#ff4d4d" },
  4: { bg: "#6699ff", text: "#ffffff", border: "#3366ff" },
  5: { bg: "#ffffaa", text: "#000000", border: "#cccc00" },
  6: { bg: "#80c080", text: "#000000", border: "#008000" },
  7: { bg: "#ffd280", text: "#000000", border: "#ffa500" },
  8: { bg: "#ffb6c1", text: "#000000", border: "#ff69b4" },
};

const JRA_PLACES = {
  "01": "札幌",
  "02": "函館",
  "03": "福島",
  "04": "新潟",
  "05": "東京",
  "06": "中山",
  "07": "中京",
  "08": "京都",
  "09": "阪神",
  "10": "小倉",
};

const readSelection = () => {
  const year = localStorage.getItem("year") || "";
  const date = localStorage.getItem("date") || "";
  const place = localStorage.getItem("place") || "";
  const raceNo = localStorage.getItem("raceNo") || "";

  if (!/^\d{4}$/.test(year) || !/^\d{4}$/.test(date) || !/^\d{2}$/.test(place) || !/^\d{1,2}$/.test(raceNo)) {
    return null;
  }

  return {
    year,
    date,
    place,
    raceNo,
    raceId: `${year}${date}${place}${raceNo.padStart(2, "0")}`,
  };
};

const findRaceHeader = () =>
  [...document.querySelectorAll("h4")].find((node) => /【\s*.+\s+\d+R】/.test(node.textContent || "")) || null;

const parseRaceInfo = (container, selection) => {
  const text = container?.textContent || "";
  const time = text.match(/(\d{2}):(\d{2})\s*発走/);
  const course = text.match(/(芝|ダート|ダ)(\d+)m/);

  return {
    HassoTime: time ? `${time[1]}${time[2]}` : "",
    RaceNum: selection.raceNo,
    JyoCD: selection.place,
    芝ダ: course?.[1] || "",
    Kyori: course?.[2] || "",
    Hondai: "",
  };
};

export default function RaceResultPortal() {
  const [mountNode, setMountNode] = useState(null);
  const [raceContext, setRaceContext] = useState(null);

  useEffect(() => {
    let currentMount = null;
    let currentContainer = null;
    let lastKey = "";

    const sync = () => {
      const heading = findRaceHeader();
      const selection = readSelection();

      if (!heading || !selection) {
        if (currentMount?.isConnected) currentMount.remove();
        if (currentContainer) currentContainer.classList.remove("race-info-with-result");
        currentMount = null;
        currentContainer = null;
        lastKey = "";
        setMountNode(null);
        setRaceContext(null);
        return;
      }

      const container = heading.parentElement;
      if (!container) return;

      if (container !== currentContainer || !currentMount?.isConnected) {
        if (currentMount?.isConnected) currentMount.remove();
        if (currentContainer) currentContainer.classList.remove("race-info-with-result");

        const node = document.createElement("div");
        node.className = "race-result-anchor";
        container.appendChild(node);
        container.classList.add("race-info-with-result");
        heading.classList.add("race-info-title-with-result");

        currentMount = node;
        currentContainer = container;
        setMountNode(node);
      }

      const raceInfo = parseRaceInfo(container, selection);
      const nextKey = `${selection.raceId}|${raceInfo.HassoTime}|${raceInfo.芝ダ}|${raceInfo.Kyori}`;

      if (nextKey !== lastKey) {
        lastKey = nextKey;
        setRaceContext({
          raceId: selection.raceId,
          raceInfo,
          placeName: JRA_PLACES[selection.place] || selection.place,
        });
      }
    };

    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener("popstate", sync);

    return () => {
      observer.disconnect();
      window.removeEventListener("popstate", sync);
      if (currentMount?.isConnected) currentMount.remove();
      if (currentContainer) currentContainer.classList.remove("race-info-with-result");
    };
  }, []);

  if (!mountNode || !raceContext) return null;

  return createPortal(
    <RaceResult
      raceId={raceContext.raceId}
      raceInfo={raceContext.raceInfo}
      placeName={raceContext.placeName}
      wakuColors={WAKU_COLORS}
    />,
    mountNode
  );
}
